import React from 'react';
import NoRows from '@/components/table/NoRows';

const CohortVisualisation = React.lazy(() => import('../containers/CohortVisualisation'));

const LazyCohortVisualisation = (props) => (
  <React.Suspense fallback={<NoRows icon="chart bar" entity="visualisation" />}>
    <CohortVisualisation {...props} />
  </React.Suspense>
);

export default LazyCohortVisualisation;
